// All site content + imagery for Greenwich Village Baths.
// Copy follows the Wedge brand voice: succinct, cordial, old-school. Placeholder
// copy for FAQ / Know Before You Go is on-brand and can be swapped by GVB.

export const IMAGES = {
  heroPool:
    "https://static.prod-images.emergentagent.com/jobs/836866ab-4c02-4484-94f5-2595cf912f99/images/9f850b0222fb34047422c55dc87d90fcb4c6661d3bf6fc37d5b592c462bae4fc.jpeg",
  aboutHeritage:
    "https://static.prod-images.emergentagent.com/jobs/836866ab-4c02-4484-94f5-2595cf912f99/images/d887cb4fbce50341ab7bfa125f5db7aa16e506753c8c9e1918c24d66838ce932.jpeg",
  textureDetail:
    "https://static.prod-images.emergentagent.com/jobs/836866ab-4c02-4484-94f5-2595cf912f99/images/24df081705dc4acdca3a2628373e7081b2d2b57b724224d0f92b7a75295ad95b.jpeg",
  pools:
    "https://static.prod-images.emergentagent.com/jobs/836866ab-4c02-4484-94f5-2595cf912f99/images/c458b3da32b05aec1d239afa1d0e4d8c0c0c7da9258c72841d848a518869a219.jpeg",
  coldPlunge:
    "https://static.prod-images.emergentagent.com/jobs/836866ab-4c02-4484-94f5-2595cf912f99/images/b424376bbf8ab16b3c7a7f093eea45709296115853827494bf5266cb44cc9581.jpeg",
  sauna:
    "https://static.prod-images.emergentagent.com/jobs/836866ab-4c02-4484-94f5-2595cf912f99/images/462b0ae6877276e2fb25f34bd654b8f3e7c5f648e8881d62eea9689b1218bcd2.jpeg",
  steam:
    "https://static.prod-images.emergentagent.com/jobs/836866ab-4c02-4484-94f5-2595cf912f99/images/67184b3a82eb71167ad853f0ec1ed36c7192983cc0616ca4e6fc309c728eb557.jpeg",
  banya:
    "https://static.prod-images.emergentagent.com/jobs/836866ab-4c02-4484-94f5-2595cf912f99/images/8fcbb1ac0a68eed7e6f71209f0db8ea936ac76e70e7350495ef014d04db9bee9.jpeg",
  bar:
    "https://static.prod-images.emergentagent.com/jobs/836866ab-4c02-4484-94f5-2595cf912f99/images/39287df6947a20318e7f2007bde32b3f4ca7ef758282e816b8c84b192e7b8ce2.jpeg",
  retail:
    "https://static.prod-images.emergentagent.com/jobs/836866ab-4c02-4484-94f5-2595cf912f99/images/594e60a8e067808ac4301625c373f5486dd1d6b04890489e0f2f5930122d32b6.jpeg",
  nyhrcBuilding: "/nyhrc-building.jpg",
  heroStreet:
    "https://static.prod-images.emergentagent.com/jobs/836866ab-4c02-4484-94f5-2595cf912f99/images/20a6f9c0cbdf5c3a84896b9876e0c0c821e8f6892f67fe7a480b23359c28afda.jpeg",
};

export const NAV_LINKS = [
  { label: "About", to: "/about" },
  { label: "Passes", to: "/passes" },
  { label: "Amenities", to: "/amenities" },
  { label: "Visit", to: "/visit" },
  { label: "FAQ", to: "/faq" },
];

export const ABOUT_CHAPTERS = [
  {
    no: "01",
    title: "The Place",
    body:
      "The Greenwich Village Baths is a bathhouse located at 24 East 13th Street, in the former home of the New York Health and Racquet Club.",
    image: IMAGES.nyhrcBuilding,
  },
  {
    no: "02",
    title: "The Family",
    body:
      "The New York Health and Racquet Club was a family business, a New York institution, and a way of life that defined culture since it opened its doors in Greenwich Village in 1973.",
    image: IMAGES.pools,
  },
  {
    no: "03",
    title: "The Spirit",
    body:
      "The Greenwich Village Baths continue that spirit. Run by the same family, in the same place.",
    image: "/spirit-towel.jpg",
  },
];

export const PASSES = [
  {
    name: "The Circuit",
    duration: "90 minutes",
    price: "From $—",
    line: "Time enough for the full round of the water.",
  },
  {
    name: "The Long Soak",
    duration: "2.5 hours",
    price: "From $—",
    line: "The unhurried version. Stay a while.",
  },
];

export const AMENITIES = [
  {
    name: "The Pools",
    temp: "98°F",
    line: "Warm mineral water for a long soak.",
    image: "/am-pools.jpg",
  },
  {
    name: "Cold Plunges",
    temp: "50°F",
    line: "Deep and cold. In, then out.",
    image: "/am-coldplunge.jpg",
  },
  {
    name: "The Sauna",
    temp: "180°F",
    line: "Dry cedar heat.",
    image: "/am-sauna-v2.jpg",
  },
  {
    name: "The Steam Room",
    temp: "115°F",
    line: "Eucalyptus steam, floor to ceiling.",
    image: "/am-steam-v2.jpg",
  },
  {
    name: "The Banya",
    temp: "200°F",
    line: "The Russian room. Bring a friend.",
    image: "/am-banya-v2.jpg",
  },
  {
    name: "The Bar",
    temp: "",
    line: "Something cold and something to eat, between rounds.",
    image: "/am-bar-v3.jpg",
  },
  {
    name: "Retail",
    temp: "",
    line: "Towels, robes, and the essentials, at the front.",
    image: "/am-retail.jpg",
  },
];

export const KNOW_BEFORE = [
  {
    title: "What's provided",
    body:
      "Towels, robes, sandals, and everything for the water. Lockers and showers are ours. Bring yourself.",
  },
  {
    title: "What to bring",
    body:
      "A bathing suit. Suits are required in all shared areas. The rest is here when you arrive.",
  },
  {
    title: "Arrival",
    body: "Come ten minutes early to change and explore the space.",
  },
  {
    title: "Etiquette",
    body:
      "Quiet voices. Phones stay in the lockers. Shower before you enter the water.",
  },
  {
    title: "Age policy",
    body: "Eighteen and over. Photo identification at the door.",
  },
];

export const LOCATION = {
  address1: "24 East 13th Street",
  address2: "New York, NY 10003",
  hours: [
    { days: "Mon–Fri", time: "9AM – 10PM" },
    { days: "Sat–Sun", time: "8AM – 10PM" },
  ],
  subway: "Union Square — 4 5 6 · N Q R W · L",
  phone: "(212) 555–1973",
  email: "hello@greenwichvillagebaths.com",
  mapUrl: "https://maps.google.com/?q=24+East+13th+Street+New+York+NY+10003",
};

export const FAQS = [
  {
    q: "Do I need to book ahead?",
    a: "Yes. Sessions are limited and sell out. Book your time before you come.",
  },
  {
    q: "What should I wear?",
    a: "A bathing suit. Suits are required in all shared areas. Robes and towels are provided.",
  },
  {
    q: "Do you provide towels and robes?",
    a: "We do. Towels, robes, and sandals are included with every pass.",
  },
  {
    q: "How long is a session?",
    a: "The Circuit is ninety minutes. The Long Soak is two and a half hours.",
  },
  {
    q: "Is there an age requirement?",
    a: "Guests must be eighteen or over. Please bring photo identification.",
  },
  {
    q: "Can I come with a group?",
    a: "Yes. Book each guest a pass for the same time. Space is limited, so book early.",
  },
  {
    q: "What are the pools and rooms?",
    a: "Warm pools, cold plunges, a sauna, a steam room, and a banya. See the amenities.",
  },
  {
    q: "Is there food and drink?",
    a: "The Bar serves something cold and something to eat, between rounds.",
  },
  {
    q: "Do you offer massages or facials?",
    a: "No. This is a bathhouse. The water is the point.",
  },
  {
    q: "What if I am late?",
    a: "A late arrival shortens your session. Come ten minutes early to change.",
  },
  {
    q: "Are lockers provided?",
    a: "Yes. Lockers and showers are included. Leave valuables at home where you can.",
  },
  {
    q: "Do you sell gift cards?",
    a: "Yes. Gift cards are available through our shop.",
  },
  {
    q: "Where are you?",
    a: "24 East 13th Street, off Union Square. The nearest trains are the 4 5 6, N Q R W, and L.",
  },
  {
    q: "Is the bathhouse accessible?",
    a: "Please call ahead and we will help you plan your visit.",
  },
];

export const FOOTER_LINKS = [
  { label: "House Rules", to: "/visit" },
  { label: "Health & Safety", to: "/visit" },
  { label: "Privacy Policy", to: "/faq" },
  { label: "Terms of Service", to: "/faq" },
  { label: "Careers", to: "/faq" },
  { label: "Press & Partnerships", href: "mailto:hello@greenwichvillagebaths.com" },
];

export const SOCIALS = [
  { label: "Instagram", href: "https://instagram.com" },
  { label: "Newsletter", href: "#join" },
];
